import React, { useState, useEffect } from "react";
import axios from "utils/axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Rating,
} from "@mui/material";
import { getDate } from "utils/utils";

type Props = {
  org: string;
};

const OrganizationReview: React.FC<Props> = ({ org }) => {
  const [reviews, setReviews] = useState<Array<any>>([]);
  const [resources, setResources] = useState<Array<any>>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [shownData, setShownData] = useState<any>({});

  useEffect(() => {
    org !== "" && getReview(org);
    getResource();
  }, [org]);

  const getReview = async (organization: string) => {
    const result = await axios.get(
      `/api/review/getByOrganization/${organization}`
    );
    setReviews(result.data);
  };

  const getResource = async () => {
    const result = await axios.get("/api/resource/getAllResourceName");
    setResources(result.data);
  };

  const handleView = (review: any) => {
    setShownData(review);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getResourceName = (favourite: any) => {
    for (let resource of resources) {
      if (resource.id === favourite.resourceId) return resource.name;
    }
  };
  return (
    <div className="grid gap-2">
      {reviews.map((review, index) => (
        <div
          className="px-[12px] py-[8px] flex items-center justify-between sm:items-start bg-gray main-text border-solid border-[1.5px] border-[#bdbdbd] rounded-sm shadow-md hover:shadow-none cursor-pointer"
          key={index}
          onClick={() => handleView(review)}
        >
          {getDate(review.date)} {review.username}{" "}
          <br className="hidden sm:block" />[
          {resources.map((resource) => {
            if (resource.id === review.resourceId) return resource.name;
            return "";
          })}
          ]
        </div>
      ))}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Review Detail</DialogTitle>
        <DialogContent>
          <p className="text-lg font-opensans font-light leading-[28px] tracking-[0.6px] mb-4 w-[540px] sm:w-full">
            {shownData.username}
            <br />
            {getDate(shownData.date) + " " + getResourceName(shownData)}
            <br />
            <Rating value={shownData.rating} readOnly />
            <br />
            {shownData.content}
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OrganizationReview;
